import {SitesApi} from "./gen";


const baseUrl =  process.env["REACT_APP_BASE_URL"];

export const siteApi = new SitesApi(undefined,"https://"+baseUrl+"/v1")